export default "__VITE_ASSET__gHcjTVgf__"